import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** GET ACCOUNT MAPPING DETAILS START *********************** */
export const getAccountMappingDetailsService = (addData: any) => {
	const data = {
		GetAccountMappingToken: addData,
	};
	const url = `${FIN_API_URL}getAccountMappingList`;
	return makeApiCall(url, data);
};
/** ***************** GET ACCOUNT MAPPING DETAILS END *********************** */

/** ***************** POST ACCOUNT MAPPING DETAILS START *********************** */
export const updateAccountMappingDetailsService = (addData: any) => {
	const data = {
		UpdateAccountMappingToken: addData,
	};
	const url = `${FIN_API_URL}updateAccountMapping`;
	return makeApiCall(url, data);
};
/** ***************** POST ACCOUNT MAPPING DETAILS END *********************** */
